export const SET_PROJECT = 'SET_PROJECT';
export const SET_DISTRICT = 'SET_DISTRICT';
export const SET_LANG = 'SET_LANG';
export const SET_UUID = 'SET_UUID';
export const SET_RUNS_ON = 'SET_RUNS_ON';
export const SET_ACCOUNT_ID = 'SET_ACCOUNT_ID';
export const SET_IS_PREVIEW = 'SET_IS_PREVIEW';
export const SET_APP_STAGE = 'SET_APP_STAGE';
export const SET_WHOLE_APP_DATA = 'SET_WHOLE_APP_DATA';
export const SET_KIDS_DATA = 'SET_KIDS_DATA';
export const SET_LM_DATA = 'SET_LM_DATA';
export const SET_RR_GAME_ONLY = 'SET_RR_GAME_ONLY';
export const SET_APP_VERSION = 'SET_APP_VERSION';
export const SET_MAIN_COLOR = 'SET_MAIN_COLOR';
export const SET_APIGW_PREFIX = 'SET_APIGW_PREFIX';
export const SET_DZ_BRAND_CONFIGS = 'SET_DZ_BRAND_CONFIGS';
